import { render, staticRenderFns } from "./deductionList-travel.vue?vue&type=template&id=01c1e0ef&scoped=true"
import script from "./deductionList-travel.vue?vue&type=script&lang=js"
export * from "./deductionList-travel.vue?vue&type=script&lang=js"
import style0 from "./deductionList-travel.vue?vue&type=style&index=0&id=01c1e0ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1e0ef",
  null
  
)

export default component.exports